import { defineComponent } from 'vue';
import { props } from './props';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = n => (_pushScopeId(""), n = n(), _popScopeId(), n);

var _hoisted_1 = {
  key: 0,
  class: "var-form-details"
};
var _hoisted_2 = {
  class: "var-form-details__message"
};
var _hoisted_3 = {
  class: "var-form-details__length"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createBlock(_Transition, {
    name: "var-form-details"
  }, {
    default: _withCtx(() => [_ctx.errorMessage || _ctx.maxlengthText ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1
    /* TEXT */
    ), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.maxlengthText), 1
    /* TEXT */
    )])) : _createCommentVNode("v-if", true)]),
    _: 1
    /* STABLE */

  });
}
export default defineComponent({
  render,
  name: 'VarFormDetails',
  props
});